import styled from 'styled-components';

const ListItem = styled('li')<{ large?: boolean }>`
  transition: all ${(props) => props.theme.transitions.normal};
  height: fit-content;
  margin-left: -11px;
  padding-left: 11px;
  overflow: hidden;

  min-height: 52px;

  &:not(:last-child) {
    margin-bottom: 8px;
  }
`;

export default ListItem;
